import { t } from 'i18next';
import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';

import { baseStyles } from '@/styles';

@customElement('fg-configurator-error')
export class FgConfiguratorError extends LitElement {
  render() {
    return html`
      <p>${t('errors.productNotFound')}</p>
    `;
  }

  static styles = [baseStyles];
}
